module.exports = __webpack_public_path__ + "static/img/1493_phase_function_Paper_PointsHejduk_Prediction.58e364f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1493_phase_function_Paper_PointsHejduk_Prediction.png
// module id = lAUK
// module chunks = 0